/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    const currentPath = window.location.pathname;
    if (cart) {
      //console.log('Cart ———————————— ↓');
      //console.log(cart);
      if (currentPath === '/cart') return;

      // update sticky cart
      const stickyCart = document.getElementById('sticky-cart');
      const gif = document.querySelector('#sticky-cart-gif');
      if (stickyCart) {
        if (cart.item_count <= 0) {
          stickyCart.style.display = 'none';
          if (gif) gif.style.display = 'initial';
          return;
        }

        stickyCart.style.display = 'block';
        if (gif) gif.style.display = 'none';
        const itemsInCart = stickyCart.querySelector('#sticky-cart-items-in-cart');
        const totalPrice = stickyCart.querySelector('#sticky-cart-total-price');

        if (itemsInCart) {
          itemsInCart.dataset.itemsInCart = cart.item_count;
        }
        if (totalPrice) {
          const priceInYen = (cart.total_price / 100).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
          totalPrice.textContent = `${priceInYen}`;
        }
      }
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // ruffruff予約販売の予約するボタンがカートページに直接遷移する不具合の緩和策
  const callback = (target) => {
    console.info('Reinit productAddButtonForm');
    const node = target[0]?.target;
    if(node) Alpine.$data(node).init();
  };

  const observer = new MutationObserver(callback);
  
  const config = { childList: true, subtree: true };
  
  const nodelist = document.querySelectorAll('[x-data="productAddButtonForm()"]');
  nodelist.forEach(node => {
    observer.observe(node, config);
  });
})();
